import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete } from '@guildeducationinc/recess';
import classNames from 'classnames';
export const AutocompleteWrapper = ({ label, hideLabel, loadOptions, defaultOptions, value, onChange, cacheOptions, errors, additionalInfo, helpText, placeholder, required, disableWeglot = false, }) => {
    return (_jsx(Autocomplete, { label: label, hideLabel: hideLabel, loadOptions: loadOptions, defaultOptions: defaultOptions, value: value, onChange: onChange, cacheOptions: cacheOptions, errors: errors, additionalInfo: additionalInfo, helpText: helpText, placeholder: placeholder, required: required, className: classNames({
            'weglot-exclude': disableWeglot,
        }) }));
};
